import { Business, User } from 'model';
import { useGetStarredBusinessQuery } from '../api/StarredBusinessApi';

/**
 * Hook to get the starred status of a business by a user.
 * @param { string } businessId the business's id
 * @param { string } userId the user's id
 * @returns { boolean | undefined } the starred status of the business for this user (undefined === loading)
 */
export function useBusinessIsStarred(businessId: Business['_id'], userId: User['_id']): boolean | undefined {
	const { data: starData, isError } = useGetStarredBusinessQuery({ businessId });
	return isError ? false : starData?.users.includes(userId);
}
